export default __webpack_public_path__ + "static/media/img_tandberg_mxp-colorBkg.2a3b7840.png";